import { Card, Divider, Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import CardHeader from "./components/CardHeader";
import PaperLink from "./components/PaperLink";
import UrlFooter from "./components/UrlFooter";
import Context from "./context";
import { ServiceUrlTypeDict } from "./CreateUrlUtils";
import LanguageParameter from "./LanguageParameter";
import RedirectsParameter from "./RedirectsParameter";
import useRedirectCardActionsStore from "./store";

// ----------------------------------------------------------------------
type Props = {
	type: string;
};

export const CreateUrlCard = ({ type }: Props) => {
	const { currentLang, translate } = useLocales();
	const [state, actions] = useRedirectCardActionsStore(currentLang, type);

	return (
		<Context.Provider value={{ state, actions }}>
			<Card sx={{ p: 3, maxWidth: 850 }}>
				<CardHeader />
				<Divider sx={{ my: 4 }} />
				<Typography variant='subtitle1'>{translate("url_panel.select_params")}</Typography>
				<Stack sx={{ mt: 2 }}>
					<LanguageParameter />
					<RedirectsParameter />
				</Stack>
				<Divider sx={{ my: 4 }} />
				<Typography variant='h6'>{`${translate("url_panel.your_url")} ${translate(
					ServiceUrlTypeDict[type]?.name
				)}`}</Typography>
				<PaperLink />
				<UrlFooter />
			</Card>
		</Context.Provider>
	);
};

export default CreateUrlCard;
